module.exports = __webpack_public_path__ + "static/3.1moveCameraLeft-1dd50a6eff3c4d9b67ed73e89b74375c.gif";